import React from 'react'
import {
  Box,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
  Typography,
} from '@mui/material'
import type { AssistantTableData } from './useAssistantChat'

interface AssistantTableCardProps {
  table: AssistantTableData
  onOpenPath?: (path: string) => void
}

export const AssistantTableCard: React.FC<AssistantTableCardProps> = ({
  table,
  onOpenPath,
}) => (
  <Box
    sx={{
      mt: 1.25,
      borderRadius: 1.5,
      border: '1px solid',
      borderColor: 'divider',
      bgcolor: 'background.paper',
      overflow: 'hidden',
    }}
  >
    <Typography variant='subtitle2' sx={{ fontWeight: 700, px: 1.25, pt: 1.25 }}>
      {table.title || 'Table'}
    </Typography>
    <Box sx={{ overflowX: 'auto', WebkitOverflowScrolling: 'touch' }}>
      <Table size='small' sx={{ minWidth: 280 }}>
        <TableHead>
          <TableRow>
            {table.columns.map(column => (
              <TableCell key={column} sx={{ fontWeight: 700, whiteSpace: 'nowrap' }}>
                {column}
              </TableCell>
            ))}
          </TableRow>
        </TableHead>
        <TableBody>
          {table.rows.map((row, index) => {
            const clickable = Boolean(row.path && onOpenPath)
            return (
              <TableRow
                key={`${row.path || 'row'}-${index}`}
                hover={clickable}
                onClick={
                  clickable && row.path
                    ? () => onOpenPath?.(row.path as string)
                    : undefined
                }
                sx={{ cursor: clickable ? 'pointer' : 'default' }}
              >
                {table.columns.map((column, cellIndex) => (
                  <TableCell key={`${column}-${cellIndex}`} sx={{ whiteSpace: 'nowrap' }}>
                    {row.cells[cellIndex] || '—'}
                  </TableCell>
                ))}
              </TableRow>
            )
          })}
        </TableBody>
      </Table>
    </Box>
  </Box>
)

export const AssistantTableList: React.FC<{
  tables: AssistantTableData[]
  onOpenPath?: (path: string) => void
}> = ({ tables, onOpenPath }) => (
  <>
    {tables.map((table, index) => (
      <AssistantTableCard
        key={`${table.title}-${index}`}
        table={table}
        onOpenPath={onOpenPath}
      />
    ))}
  </>
)
